import { isClipHopeless, isClipReady } from "./clipState";
import type { HighlightsMatch } from "./Highlight";
import type { HighlightsSearch } from "./highlightsSearchSchema";

// Матчи раздела под фильтром: герой, готовые клипы или моменты без клипа. Моменты, клип которых
// не сделать никогда, не показываем; матч без моментов под фильтром пропадает.
export const filterMatches = (
  matches: HighlightsMatch[],
  { show, hero }: Pick<HighlightsSearch, "show" | "hero">,
): HighlightsMatch[] =>
  matches
    .filter((match) => hero === undefined || match.hero_id === hero)
    .map((match) => ({
      ...match,
      items: match.items.filter(
        (highlight) =>
          !isClipHopeless(highlight) &&
          (show === undefined || (show === "ready") === isClipReady(highlight)),
      ),
    }))
    .filter((match) => match.items.length > 0);
